/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Thresholds_Add_Ftp_WeightInputs */

const en_ui_thresholds_add_ftp_weight = /** @type {(inputs: Ui_Thresholds_Add_Ftp_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add FTP and weight`)
};

const de_ui_thresholds_add_ftp_weight = /** @type {(inputs: Ui_Thresholds_Add_Ftp_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FTP und Gewicht eintragen`)
};

/**
* | output |
* | --- |
* | "Add FTP and weight" |
*
* @param {Ui_Thresholds_Add_Ftp_WeightInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_thresholds_add_ftp_weight = /** @type {((inputs?: Ui_Thresholds_Add_Ftp_WeightInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Thresholds_Add_Ftp_WeightInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_thresholds_add_ftp_weight(inputs)
	return de_ui_thresholds_add_ftp_weight(inputs)
});